var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMapStart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 48,
    viewBox: "0 0 46 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#map-start_svg__filter0_d_76505_107154)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 2c6.627 0 12 5.373 12 12 0 5.652-3.907 10.391-9.168 11.664-.765.186-1.792 1.648-2.376 2.574a.551.551 0 01-.918.004c-.594-.929-1.636-2.401-2.37-2.578C14.908 24.39 11 19.652 11 14c0-6.627 5.373-12 12-12z",
    fill: "#2257D4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 37,
    r: 4,
    fill: "#2257D4",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.938 18.549c-.008.344-.008.652 0 .926a43.82 43.82 0 00-2.485.773 7.3 7.3 0 00-.844.387l-.515-.715c.187-.156.281-.426.281-.809v-.908a17.63 17.63 0 01-2.695 1.26 6.422 6.422 0 00-.528-.832c2.086-.672 3.733-1.57 4.94-2.696h-4.787v-.82h5.49a18.68 18.68 0 00-.557-.844l.75-.457c.266.391.512.75.739 1.079l-.375.222h5.414v.82h-5.338a5.404 5.404 0 001.283 1.647c.871-.418 1.73-.861 2.578-1.33l.492.855c-.777.309-1.568.64-2.373.99.91.579 2.049.967 3.416 1.167-.234.312-.449.605-.644.879-2.532-.497-4.34-1.74-5.426-3.733-.445.442-.95.858-1.512 1.248v1.711c.93-.258 1.828-.531 2.695-.82zm-1.641-5.602h2.543V11.39h-2.953v-.809h2.953V8.998h.879v1.582h3.023v.809H25.72v1.558h2.625v.809h-6.047v-.809zm-1.805-3.972h.867v5.402h-.867v-1.799c-.844.485-1.726.998-2.648 1.541a13.25 13.25 0 00-.48-.867 74.836 74.836 0 003.128-1.682V8.975zm-2.812 1.16l.62-.61c.712.586 1.247 1.059 1.606 1.418l-.703.68a20.202 20.202 0 00-1.523-1.488z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "map-start_svg__filter0_d_76505_107154",
    x: 7,
    y: 0,
    width: 32,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.2 0 0 0 0 0.466667 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_76505_107154"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_76505_107154",
    result: "shape"
  })))));
}

export default SvgMapStart;